export default "__VITE_ASSET__BaLglKFd__"